<template>
  <div
    class="yxtbiz-ai-create-ques yxtbiz-intelligent-questioning"
    :class="{
      'yxtbiz-ai-create-ques--left': editDisplay > 0,
      'yxtbiz-ai-create-ques--right': editDisplay < 0,
      'yxtbiz-ai-create-ques--ready': saveReady,
      'yxtbiz-ai-create-ques--saving': saving
    }"
  >
    <div class="yxtbiz-ai-create-ques__container">
      <!-- 左侧出题方式菜单 -->
      <div class="yxtbiz-ai-create-ques__left-bar">
        <yxt-tooltip
          :open-delay="300"
          :hide-delay="0"
          :content="$t('pc_biz_ote_btn_aicreatequestab' /** AI出题 */)"
          :placement="'right'"
        >
          <div
            v-if="aiEnable || createType === 1"
            :class="{
              actived: createType === 1
            }"
            @click="changeCreateType(1)"
          >
            <yxt-svg
              :remote-url="SvgMediaNewUrl"
              width="32px"
              height="32px"
              icon-class="ai"
            ></yxt-svg>
          </div>
        </yxt-tooltip>
        <yxt-tooltip
          :open-delay="300"
          :hide-delay="0"
          :content="$t('pc_biz_ote_btn_quickcreatequestab' /** 快速建题 */)"
          :placement="'right'"
        >
          <div
            :class="{
              actived: createType === 0
            }"
            @click="changeCreateType(0)"
          >
            <yxt-svg
              :remote-url="SvgMediaNewUrl"
              width="32px"
              height="32px"
              icon-class="ai-fast2"
            ></yxt-svg>
          </div>
        </yxt-tooltip>
      </div>
      <!-- AI对话区域 -->
      <div class="yxtbiz-ai-create-ques__left" ref="talkArea">
        <!-- AI出题 -->
        <ai-create-ques
          v-show="createType === 1"
          :libId="libInfo.libId"
          :libName="libInfo.libName"
          @addQues="addQuesList"
          ref="aiCreator"
        />
        <!-- 快速建题 -->
        <quick-create-ques
          v-if="createType === 0 || aiEnable"
          v-show="createType === 0"
          :libId="libInfo.libId"
          :libName="libInfo.libName"
          @addQues="addQuesList"
          ref="quickCreator"
        />
      </div>
      <!-- 试题编辑 -->
      <div class="yxtbiz-ai-create-ques__right">
        <!-- 试题列表空提示 -->
        <yxt-empty v-if="!usedQuesList.length && !newQues" class="yxtbiz-ote-height-100">
          <div slot="text" class="yxt-empty__text mh12">
            <!-- 试题验证区域：可编辑修改试题、手动添加试题 -->
            <div>{{ $t('pc_biz_ote_lbl_quesgeneratedtips2') }}</div>
            <div class="mt12">
              <yxt-button type="text" @click="createNewQues">
                <div class="flex flex-mid">
                  <yxt-svg
                    width="16px"
                    height="16px"
                    class="mr4"
                    icon-class="common_plus"
                  ></yxt-svg>
                  {{ $t('pc_biz_ote_btn_addques' /** 添加试题 */) }}
                </div>
              </yxt-button>
            </div>
          </div>
        </yxt-empty>
        <!-- 试题列表 -->
        <div v-else class="yxtbiz-ote-height-100 flex flex-vertical">
          <!-- 试题数统计 -->
          <div v-if="usedQuesList.length" class="flex-g-0 flex-shrink-0 flex flex-vertical flex-mid">
            <div
              :class="
                isShowMsgError ? 'yxtbiz-ai-create-ques__msgs--error' : ''
              "
              class="yxtbiz-ai-create-ques__msgs"
            >
              <div class="flex flex-between">
                <div class="shrink1 flex-g-1 flex flex-top">
                  <yxt-svg
                    v-if="!isShowMsgError"
                    width="14px"
                    height="14px"
                    class="mr8 mt4"
                    icon-class="message-success"
                  ></yxt-svg>
                  <span v-html="checkTip"></span>
                </div>
                <div
                  v-if="isShowMsgError"
                  class="shrink0 flex-g-0 pl8 flex flex-mid"
                >
                  <yxt-tooltip
                    :content="$t('pc_biz_ote_btn_preverrorques')"
                    placement="top"
                  >
                    <yxt-svg
                      width="20px"
                      height="20px"
                      class="hand hover-bg-white border-radius-4"
                      icon-class="arrow_left"
                      @click.native="scrollToQues(true, -1)"
                    ></yxt-svg>
                  </yxt-tooltip>
                  <yxt-tooltip
                    :content="$t('pc_biz_ote_btn_nexterrorques')"
                    placement="top"
                  >
                    <yxt-svg
                      width="20px"
                      height="20px"
                      class="hand hover-bg-white ml8 border-radius-4"
                      icon-class="arrow_right"
                      @click.native="scrollToQues(true, 1)"
                    ></yxt-svg>
                  </yxt-tooltip>
                </div>
              </div>
            </div>
          </div>
          <!-- 试题 -->
          <div
            class="flex-g-1 shrink1 overflow-auto yxtbiz-ai-create-ques__right-ques-list"
          >
            <yxt-scrollbar :fit-height="true" ref="refQues">
              <div
                class="yxtbiz-ai-create-ques__right-ques-list-inner flex flex-vertical flex-mid flex-center"
              >
                <ques-simple-view-info
                  v-for="(ques, index) in usedQuesList"
                  :key="ques._id"
                  ref="quesView"
                  :index="index + 1"
                  :quesBody="ques"
                  :otherEditing="editing"
                  :batching="batching"
                  :examId="examId"
                  @delete="deleteQues(ques, index)"
                  @editStart="editQuesStart(index)"
                  @editCancel="editCancel(ques, index)"
                  @edit="editQuesFinish(ques, index)"
                  @check="handleCheckedQuesChange"
                />
                <ques-simple-view-info
                  v-if="newQues"
                  ref="quesViewNew"
                  create
                  :index="usedQuesList.length + 1"
                  :quesBody="newQues"
                  :otherEditing="false"
                  :libId="libInfo.libId"
                  :libName="libInfo.libName"
                  :examId="examId"
                  @editCancel="cancelSaveNewQues"
                  @edit="saveNewQues"
                />
              </div>
            </yxt-scrollbar>
          </div>
          <div v-if="usedQuesList.length" class="yxtbiz-ai-create-ques__right-batch-options">
            <template v-if="!batching">
              <yxt-button type="text2" class="color-gray-9 mr20" @click="createNewQues">
                <div class="flex flex-mid">
                  <yxt-svg
                    width="16px"
                    height="16px"
                    class="mr4"
                    icon-class="common_plus"
                  ></yxt-svg>
                  {{ $t('pc_biz_ote_btn_addques' /** 添加试题 */) }}
                </div>
              </yxt-button>
              <yxt-button type="text2" class="color-gray-9" @click="batching = true">
                <div class="flex flex-mid">
                  <yxt-svg
                    width="16px"
                    height="16px"
                    class="mr4"
                    :remote-url="SvgMediaNewUrl"
                    icon-class="ai-batch"
                  ></yxt-svg>
                  {{ $t('pc_biz_ote_btn_batchdo' /** 批量操作 */) }}
                </div>
              </yxt-button>
            </template>
            <template v-else>
              <yxt-checkbox v-model="checkedAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">{{ $t('h5_biz_ote_btn_selectall')/** 全选 */ }}</yxt-checkbox>
              <div class="flex flex-g-1 flex-right flex-mid">
                <yxt-button type="text2" class="color-gray-9 mr20" @click="batchChangeLib">
                  <div class="flex flex-mid">
                    <yxt-svg
                      width="16px"
                      height="16px"
                      class="mr4"
                      :remote-url="SvgMediaNewUrl"
                      icon-class="ai-lib"
                    ></yxt-svg>
                    {{ $t('pc_biz_ote_btn_changelib' /** 换库 */) }}
                  </div>
                </yxt-button>
                <yxt-button type="text2" class="color-gray-9 mr16" @click="batchDeleteQues">
                  <div class="flex flex-mid">
                    <yxt-svg
                      width="16px"
                      height="16px"
                      class="mr4"
                      icon-class="delete"
                    ></yxt-svg>
                    {{ $t('pc_biz_ote_btn_delete' /** 删除 */) }}
                  </div>
                </yxt-button>
                <yxt-divider direction="vertical"></yxt-divider>
                <yxt-button type="text" class="mr24" @click="batching = false">
                  <div class="flex flex-mid">
                    {{ $t('pc_biz_quit' /** 退出 */) }}
                  </div>
                </yxt-button>
              </div>
            </template>
          </div>
          <!-- 选择题库 -->
          <yxt-drawer
            :title="$t('pc_biz_ote_msg_selqueslib')"
            :visible.sync="selectLibDrawerData.isShowSelectLibDrawer"
            size="960px"
            class="yxtbiz-lib-selector__select-drawer"
            :destroy-on-close="true"
            :before-close="
              done => done($refs.selectLib && $refs.selectLib.dialogEdited)
            "
          >
            <yxtbiz-lib-selector
              ref="selectLib"
              needCreateLib
              :createType="examId ? 1 : 0"
              :states="selectLibDrawerData"
              @selectLibCallback="selectLibCallback"
              @closeSelectLibDrawer="closeSelectLibDrawer"
            />
            <div slot="footer">
              <!--取 消-->
              <yxt-button plain @click="selectLibClose">{{
                $t('pc_biz_ote_btn_cancle')
              }}</yxt-button>
              <!--确 定-->
              <yxt-button type="primary" @click="selectLibSubmit">{{
                $t('pc_biz_ote_btn_confirm')
              }}</yxt-button>
            </div>
          </yxt-drawer>
        </div>
      </div>
      <!-- 切换编辑区 -->
      <div class="yxtbiz-ai-create-ques__bar">
        <div>
          <yxt-tooltip
            v-if="editDisplay <= -1"
            :open-delay="500"
            :hide-delay="0"
            :key="'btnr_' + editDisplay"
            :content="
              $t(
                editDisplay < 0
                  ? 'pc_biz_ote_btn_aieditfullexit'
                  : 'pc_biz_ote_btn_aitalkfull'
              )
            "
            :placement="editDisplay < 0 ? 'right' : 'top'"
          >
            <div @click="tabEdit(1)">
              <yxt-svg
                width="16px"
                height="16px"
                class="hand"
                icon-class="arrow_right"
              ></yxt-svg>
            </div>
          </yxt-tooltip>
          <yxt-tooltip
            v-if="editDisplay >= 0"
            :open-delay="500"
            :hide-delay="0"
            :key="'btnl_' + editDisplay"
            :content="
              $t(
                editDisplay > 0
                  ? 'pc_biz_ote_btn_aitalkfullexit'
                  : 'pc_biz_ote_btn_aieditfull'
              )
            "
            :placement="editDisplay > 0 ? 'left' : 'top'"
          >
            <div @click="tabEdit(-1)">
              <yxt-svg
                width="16px"
                height="16px"
                class="hand"
                icon-class="arrow_left"
              ></yxt-svg>
            </div>
          </yxt-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>
<script type='text/ecmascript-6'>
import { QUES_TYPE_NAMES, SvgMediaNewUrl } from './const';
import { getGuid, handleError, initQues } from './utils';

import quesSimpleViewInfo from './ques/quesSimpleViewInfo';

// import { getFunStatus } from '../../common-util/factorUtils';
// import { enmuFunctions } from '../../function-points';
import aiCreateQues from './input/aiCreateQues.vue';
import quickCreateQues from './input/quickCreateQues.vue';

import { createQuesQuick, getDefaultLib } from './ques.service';

export default {
  name: 'IntelligentCreateQues',
  props: {
    // 题库ID
    libId: {
      type: String,
      default: ''
    },
    // 题库名
    libName: {
      type: String,
      default: ''
    },
    // 试卷ID
    examId: {
      type: String,
      default: ''
    },
    // ai功能是否开启
    aiEnable: {
      type: Boolean,
      default: false
    },
    // 0:快速出题  1：AI出题
    type: {
      type: Number,
      default: 1
    }
  },
  components: {
    quesSimpleViewInfo,
    aiCreateQues,
    quickCreateQues
  },
  data() {
    return {
      pointsSupport: false,
      SvgMediaNewUrl,
      QUES_TYPE_NAMES,
      createType: 0, // 0:快速出题  1：AI出题

      usedQuesList: [], // 引用的问题
      libInfo: {}, // 默认题库信息，导入默认进入默认题库
      newQues: null, // 创建试题

      selectLibDrawerData: {
        isShowSelectLibDrawer: false,
        libId: '',
        libName: ''
      },

      batching: false,
      checkedAll: false,
      isIndeterminate: false,
      saving: false,
      editing: false,
      isShowMsgError: false,
      editDisplay: 0, // 页面布局方式
      errorQuesCount: 0, // 错题数
      errorQuesIndex: -1 // 错题序号
    };
  },
  watch: {
    type: {
      immediate: true,
      handler(val) {
        this.createType = val;
      }
    },
    batching: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.usedQuesList.forEach((q, i) => {
            q.checked = false;
          });
          this.isIndeterminate = false;
          this.checkedAll = false;
        } else if (this.editing) {
          this.$message({
            showClose: false,
            message: this.$t('pc_biz_ote_msg_confirmquestionediting'), // 请先确认正在编辑的试题
            type: 'info'
          });
          this.batching = false;
        }
      }
    }
  },
  created() {
    this.libInfo = {
      libId: this.libId,
      libName: this.libName
    };
    !this.libInfo.libId &&
      getDefaultLib()
        .then(res => {
          this.libInfo = {
            libId: res.id,
            libName: res.name
          };
        })
        .catch(handleError.bind(this));

  },
  computed: {
    userInfo() {
      return {
        userName: window.localStorage.username,
        userShortName: window.localStorage.fullname,
        headPictureUrl: window.localStorage.imgUrl
      };
    },
    // 出题数量菜单数据源
    quesCountMenus() {
      return [1, 2, 3, 4, 5]
        .filter((e, i) => i < 5)
        .map(c => ({ id: c, name: c }));
    },
    // 出题类型菜单数据源
    quesTypeMenus() {
      const icons = [
        'compose',
        'singlechoice',
        'multiplechoice',
        'judgment',
        'fillin',
        'shortanswer'
      ];
      const menus = QUES_TYPE_NAMES.filter((e, i) => i < 5).map(
        (tn, index) => ({ id: index, name: this.$t(tn) })
      );
      menus.unshift({ id: -1, name: this.$t('pc_biz_ote_lbl_randomques') });
      menus.forEach((m, index) => {
        m.icon = icons[index];
      });
      return menus;
    },
    // 验证试题后的提示文本
    checkTip() {
      let infos = '';
      const quesCount = this.usedQuesList.length;
      if (!this.isShowMsgError) {
        // 无错误
        infos = this.$t('pc_biz_ote_lbl_correctquescount', [quesCount]);
        const quesCounts = [];
        this.quesTypeCount.SingleChoice &&
          quesCounts.push(
            `${this.quesTypeCount.SingleChoice} ${this.$t(
              'pc_biz_ote_lbl_questype0'
            )}`
          );
        this.quesTypeCount.MultiChoice &&
          quesCounts.push(
            `${this.quesTypeCount.MultiChoice} ${this.$t(
              'pc_biz_ote_lbl_questype1'
            )}`
          );
        this.quesTypeCount.Judge &&
          quesCounts.push(
            `${this.quesTypeCount.Judge} ${this.$t('pc_biz_ote_lbl_questype2')}`
          );
        this.quesTypeCount.FillIn &&
          quesCounts.push(
            `${this.quesTypeCount.FillIn} ${this.$t(
              'pc_biz_ote_lbl_questype3'
            )}`
          );
        this.quesTypeCount.QuestionAndAnswer &&
          quesCounts.push(
            `${this.quesTypeCount.QuestionAndAnswer} ${this.$t(
              'pc_biz_ote_lbl_questype4'
            )}`
          );

        infos += '，' + quesCounts.join('，');
      } else {
        // 包含错误
        infos = this.$t('pc_biz_ote_lbl_errorquescount', [
          quesCount,
          `<span class="color-error">${this.errorQuesCount}</span>`
        ]);
      }
      return infos;
    },
    // 已引用的各题型的题数
    quesTypeCount() {
      return {
        SingleChoice: this.usedQuesList.filter(q => q.type === 0).length,
        MultiChoice: this.usedQuesList.filter(q => q.type === 1).length,
        Judge: this.usedQuesList.filter(q => q.type === 2).length,
        FillIn: this.usedQuesList.filter(q => q.type === 3).length,
        QuestionAndAnswer: this.usedQuesList.filter(q => q.type === 4).length
      };
    },
    // 是否可以保存题目了
    saveReady() {
      const isReady = !this.isShowMsgError && this.usedQuesList.length > 0;
      this.$emit('createReadyChange', isReady);
      return isReady;
    },
    checkedCount() {
      return this.usedQuesList.filter(q => q.checked).length;
    }
  },
  mounted() {},
  methods: {
    // 切换出题方式
    changeCreateType(type) {
      this.createType = type;
      this.editDisplay = 0;

      this.$refs.quickCreator && this.$refs.quickCreator.closeStandardFormatExample();
    },
    // 切换页面编辑区
    tabEdit(type) {
      this.editDisplay = this.editDisplay + type;
    },
    // 定位下一道题
    scrollToQues(goErrorQues, step) {
      setTimeout(() => {
        const quesScroll = this.$refs.refQues.$el.children[0];
        const quesViewS = this.$refs.quesView;
        if (goErrorQues) {
          // 只定位错题
          let targetErrorQuesIndex = this.errorQuesIndex + step;
          let currentErrorQuesIndex = -1;
          let quesIndex = -1;
          let firstIndex = -1;
          let lastIndex = -1;
          for (let index = 0; index < this.usedQuesList.length; index++) {
            const q = this.usedQuesList[index];
            if (q.error) {
              currentErrorQuesIndex++;

              if (firstIndex === -1) {
                firstIndex = index;
              }
              lastIndex = index;
            }

            if (
              currentErrorQuesIndex !== -1 &&
              currentErrorQuesIndex === targetErrorQuesIndex
            ) {
              quesIndex = index;
              break;
            }
          }

          if (targetErrorQuesIndex < 0) {
            quesIndex = lastIndex;
            targetErrorQuesIndex = currentErrorQuesIndex;
          } else if (targetErrorQuesIndex > 0 && quesIndex === -1) {
            quesIndex = firstIndex;
            targetErrorQuesIndex = 0;
          }

          this.errorQuesIndex = targetErrorQuesIndex;

          if (quesViewS && quesViewS[quesIndex]) {
            quesScroll.scrollTop = quesViewS[quesIndex].$el.offsetTop - 12;

            this.usedQuesList.forEach((q, index) => {
              q.showError = quesIndex === index;
            });
          }
        } else {
          quesScroll.scrollTop =
            step === -1
              ? quesScroll.scrollHeight
              : quesViewS[step].$el.offsetTop - 12;
        }
      });
    },
    createNewQues() {
      if (this.editing) {
        this.$message({
          showClose: false,
          message: this.$t('pc_biz_ote_msg_confirmquestionediting'), // 请先确认正在编辑的试题
          type: 'info'
        });
        return false;
      }

      this.editing = true;
      this.newQues = initQues(0, this.libInfo.libId, this.libInfo.libName);
      this.newQues.sourceType = 0;

      setTimeout(() => {
        const quesScroll = this.$refs.refQues.$el.children[0];
        const quesViewS = this.$refs.quesViewNew;
        quesScroll.scrollTop = quesViewS.$el.offsetTop - 12;
      });
    },
    cancelSaveNewQues() {
      this.editing = false;
      this.newQues = null;
    },
    saveNewQues(ques, index) {
      this.editing = false;
      this.addQuesList([this.newQues]);
      this.newQues = null;
    },
    // 引用AI出的题目  type: 0 手动添加 ， 1 快速建题  4 ai出题
    addQuesList(quesList, cb, type = 0) {
      if (this.editing || this.batching) {
        this.$message({
          showClose: false,
          message: this.$t(this.editing ? 'pc_biz_ote_msg_confirmquestionediting'/** 请先确认正在编辑的试题 */ : 'pc_biz_ote_msg_quitbatch' /** 请先退出批量操作 */),
          type: 'info'
        });
        cb && cb(false);
        return false;
      }
      if (this.usedQuesList.length >= 100) {
        this.$message({
          showClose: false,
          message: this.$t('pc_biz_ote_msg_nomorethanques', [100]), // 最大不能超过100道试题
          type: 'warning'
        });
        cb && cb(false);
        return false;
      }
      quesList.forEach(ques => {
        if (!ques._id) {
          ques._id = getGuid();
        }
        ques.showError = 0;
        ques.sourceType = type;
        this.usedQuesList.push(ques);
      });
      // 滚动至底部
      this.scrollToQues(false, -1);
      this.setIsShowMsgError();
      cb && cb(true);
    },
    // 废弃已引用的题目
    deleteQues(ques) {
      if (this.editing) {
        this.$message({
          showClose: false,
          message: this.$t('pc_biz_ote_msg_confirmquestionediting'), // 请先确认正在编辑的试题
          type: 'info'
        });
        return false;
      }

      ques.edited = false;
      if (ques.quesEdited) {
        // 删除试题 不保留之前编辑的结果
        delete ques.quesEdited;
      }

      let index = 0;
      this.usedQuesList.forEach((q, i) => {
        if (q === ques) index = i;
      });
      this.usedQuesList.splice(index, 1);

      this.setIsShowMsgError();

      this.$refs.aiCreator && this.$refs.aiCreator.deleteQues(ques);
    },
    batchDeleteQues() {
      if (this.checkedCount <= 0) {
        this.$message({
          showClose: false,
          message: this.$t('pc_biz_ote_msg_batchnoques'), // 请先勾选试题
          type: 'info'
        });
        return false;
      }
      const checkedQues = this.usedQuesList.filter(q => q.checked);
      checkedQues.forEach((ques, index) => {
        ques.checked && this.deleteQues(ques);
      });

      this.$message({
        type: 'success',
        message: this.$t('pc_biz_ote_msg_successdone' /** 操作成功 */)
      });

      this.handleCheckedQuesChange();
      // this.batching = false;
      if (this.usedQuesList.length === 0) this.batching = false;
    },
    batchChangeLib() {
      if (this.checkedCount <= 0) {
        this.$message({
          showClose: false,
          message: this.$t('pc_biz_ote_msg_batchnoques'), // 请先勾选试题
          type: 'info'
        });
        return false;
      }

      this.selectLibDrawerData.isShowSelectLibDrawer = true;
      this.selectLibDrawerData.libId = '';
      this.selectLibDrawerData.libName = '';
    },
    // 选择题库回调
    selectLibCallback(libId, libName) {
      this.usedQuesList.filter(q => q.checked).forEach((ques, index) => {
        const q = ques.quesEdited || ques;
        if (q.libId !== libId) {
          q.pointIds = [];
        }
        q.libId = libId;
        q.libName = libName;
      });

      this.$message({
        type: 'success',
        message: this.$t('pc_biz_ote_msg_successdone' /** 操作成功 */)
      });
      // this.batching = false;

      this.selectLibClose();
    },
    // 关闭选择题库抽屉
    closeSelectLibDrawer() {
      this.selectLibDrawerData.isShowSelectLibDrawer = false;
    },
    selectLibClose() {
      this.$refs.selectLib.close();
    },
    selectLibSubmit() {
      this.$refs.selectLib.submit();
    },
    handleCheckAllChange(val) {
      this.usedQuesList.forEach((q) =>{
        q.checked = val;
      });
      this.isIndeterminate = false;
    },
    handleCheckedQuesChange() {
      this.checkedAll = this.checkedCount > 0 && this.checkedCount === this.usedQuesList.length;
      this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.usedQuesList.length;
    },
    // 开始编辑试题
    editQuesStart(index) {
      this.editing = true;
      this.scrollToQues(false, index);
    },
    editCancel(ques, index) {
      this.editing = false;
    },
    // 编辑试题完成
    editQuesFinish(ques, index) {
      this.editing = false;
      this.setIsShowMsgError();
      this.scrollToQues(false, index);
    },
    // 是否需要显示试题错误消息
    setIsShowMsgError() {
      this.errorQuesCount = this.usedQuesList.filter(
        e => e.error && !e.edited
      ).length;
      this.isShowMsgError = this.errorQuesCount > 0;
    },
    // 确认导入试题
    saveQuestions(cb) {
      if (this.editing) {
        this.$message({
          showClose: false,
          message: this.$t('pc_biz_ote_msg_confirmquestionediting'), // 请先确认正在编辑的试题
          type: 'info'
        });
        return false;
      }

      const quickCreateBean = {
        examId: this.examId,
        questions: this.usedQuesList.map(ques => {
          // 防止接口报错导致下方删除字段会导致页面用到的地方出问题
          const quesEdited = JSON.parse(JSON.stringify(ques.quesEdited || ques));

          // 清理接口不需要的属性
          delete quesEdited.origin;
          delete quesEdited.talkId;
          delete quesEdited.error;
          delete quesEdited.errorMsg;
          delete quesEdited.edited;
          delete quesEdited._id;

          return quesEdited;
        })
      };
      this.saving = true;
      // 快速建题
      createQuesQuick(quickCreateBean)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t(
              'pc_biz_ote_msg_importquessuccess' /** 已成功导入X题 */,
              [this.usedQuesList.length]
            )
          });

          this.$emit('created');
        })
        .catch(err => {
          handleError.bind(this)(err);
        })
        .finally(() => {
          this.saving = false;
          cb && cb();
        });
      return true;
    },
    hasQuesInfos() {
      return this.usedQuesList.length > 0;
    },
    aiGenerating() {
      return this.$refs.aiCreator && this.$refs.aiCreator.asking;
    }
  }
};
</script>
